import { CardSize } from "./types"

export const SQUARE_CARD_PADDINGS_MAPPING: Record<CardSize, string> = {
  none: "p-0",
  xxs: "p-1",
  xs: "p-2",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
}

/**
 * The Squish variant does not support sizes 'none' and 'xxs'.
 * For simplicity sake, the paddings at these sizes are mapped to 'p-0'
 */
export const SQUISH_CARD_PADDINGS_MAPPING: Record<Exclude<CardSize, "none" | "xxs">, string> = {
  xs: "px-2 py-[0.375rem]",
  sm: "px-3 py-2",
  md: "px-4 py-3",
  lg: "px-6 py-5",
}
